import { BaseResource } from '../base-resource';

export class Event extends BaseResource {
    constructor() {
        super();
        this.type = "PrivateEvent";
    }
}